import { setConfig } from '@faustwp/core';
import templates from './wp-templates';
import possibleTypes from './possibleTypes.json';
import stripCanonizeResultsPlugin from './lib/apolloStripCanonizeResults';

/** Custom GraphQL endpoint path (WordPress uses /graphql instead of /index.php?graphql) */
function customGraphQLEndpointPlugin() {
  return {
    apply({ addFilter }) {
      addFilter('graphqlEndpoint', 'customGraphQLEndpoint', (graphqlEndpoint, { wpUrl }) => {
        if (!wpUrl || typeof wpUrl !== 'string') return graphqlEndpoint;
        const base = wpUrl.replace(/\/+$/, '').trim();
        return base ? `${base}/graphql` : graphqlEndpoint;
      });
    },
  };
}

/**
 * @type {import('@faustwp/core').FaustConfig}
 **/
export default setConfig({
  templates,
  plugins: [stripCanonizeResultsPlugin(), customGraphQLEndpointPlugin()],
  experimentalToolbar: true,
  possibleTypes,
});
